export interface FormItems<T> {
  items: T[];
}

export interface FormProps {
  showModal: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export enum FormSubmissionStatus {
  SUBMITTING = 'Submitting...',
  SUBMITTED_SUCCESSFULLY = 'Submitted successfully',
  SUBMIT_ERROR = 'Unable to submit',
}
